<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <div
    class="fixed z-50 inset-0 overflow-y-auto"
    aria-labelledby="modal-title"
    role="dialog"
    aria-modal="true"
  >
    <div
      class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
    >
      <div
        class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        aria-hidden="true"
      ></div>

      <!-- This element is to trick the browser into centering the modal contents. -->
      <span
        class="hidden sm:inline-block sm:align-middle sm:h-screen"
        aria-hidden="true"
        >&#8203;</span
      >
      <div
        class="inline-block align-middle bg-white rounded-xl text-left overflow-hidden shadow-2xl transform transition-all w-full sm:w-11/12 md:w-2/3 lg:w-1/2 my-8"
      >
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="flex flex-col bg-white rounded p-2 sm:p-6">
            <div class="flex items-center justify-between mb-8 pb-4 border-b border-gray-100">
              <h3
                class="text-lg leading-6 font-semibold text-gray-900"
                id="modal-title"
              >
                Create New RDE
              </h3>
              <button type="button" class="text-gray-400 hover:text-gray-600 transition-colors" @click="cancelRDEAccount" aria-label="Close">
                <i class="fas fa-times text-lg"></i>
              </button>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Email</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <input
                  type="text"
                  class="border border-gray-200 rounded-lg p-2.5 w-full text-sm focus:outline-none focus:border-express"
                  v-model.trim="form.email"
                  autocomplete="email"
                />
              </div>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Password</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <input
                  type="text"
                  class="border border-gray-200 rounded-lg p-2.5 w-full text-sm focus:outline-none focus:border-express"
                  v-model.trim="form.password"
                />
              </div>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Confirm Password</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <input
                  type="text"
                  class="border border-gray-200 rounded-lg p-2.5 w-full text-sm focus:outline-none focus:border-express"
                  v-model.trim="form.comfirm_password"
                />
              </div>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Phone</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <input
                  type="text"
                  class="border border-gray-200 rounded-lg p-2.5 w-full text-sm focus:outline-none focus:border-express"
                  v-model.trim="form.phone"
                  placeholder="e.g 234XXXXXXXXXX"
                />
              </div>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Name</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <input
                  type="text"
                  class="border border-gray-200 rounded-lg p-2.5 w-full text-sm focus:outline-none focus:border-express"
                  v-model.trim="form.name"
                  placeholder="Full Name"
                />
              </div>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Account Type</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <select
                  v-model.trim="form.type"
                  class="border border-gray-200 rounded-lg p-2.5 w-full text-sm focus:outline-none focus:border-express"
                >
                  <option value="rde">RDE</option>
                </select>
              </div>
            </div>

            <div class="flex flex-col sm:flex-row sm:items-center justify-between mt-4">
              <p class="text-sm font-medium text-expressgray sm:w-1/3">Country</p>
              <div class="flex space-x-2 sm:w-2/3 justify-between mt-1 sm:mt-0">
                <select
                  v-model.trim="form.country"
                  class="border border-gray-200 rounded-lg p-2.5 w-full text-sm focus:outline-none focus:border-express"
                >
                  <option value="Nigeria">Nigeria</option>
                  <option value="Ghana">Ghana</option>
                  <option value="CIV">Cote d'Ivoire</option>
                </select>
              </div>
            </div>

            <div
              class="flex flex-col sm:flex-row items-center justify-end gap-3 mt-8 pt-4 border-t border-gray-100"
            >
              <button
                type="button"
                class="w-full sm:w-auto inline-flex justify-center rounded-lg px-5 py-2.5 bg-express text-sm font-medium text-white hover:bg-expressbutton transition-colors"
                @click="completeRDEAccount"
              >
                Create RDE Account
              </button>
              <button
                type="button"
                class="w-full sm:w-auto inline-flex justify-center rounded-lg border border-gray-200 px-5 py-2.5 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors"
                @click="cancelRDEAccount"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "add_retailer_model",
  props: [],
  emits: ["completeRDEAccount", "cancelRDEAccount"],
  data() {
    return {
      form: {
        email: null,
        password: null,
        comfirm_password: null,
        phone: null,
        name: null,
        type: "rde",
        country: null,
      },
    };
  },
  watch: {
    // 'form.country' : {
    //   handler(newVal, oldVal){  // here having access to the new and old value
    //     // do stuff
    //     // console.log("country", newVal)
    //     if(newVal==="Nigeria"){
    //       this.states_option = this.states.Nigeria
    //       this.zones_option = this.zones.Nigeria
    //     }else{
    //       this.states_option = this.states.Ghana
    //       this.zones_option = this.zones.Ghana
    //     }
    //   },
    //   deep: true,
    //   immediate: true
    // }
  },

  methods: {
    emailValidate: function (email) {
      const regexp = /^[\w.%+-]+@[\w.-]+\.[\w]{2,6}$/;
      return regexp.test(email);
    },
    phoneValidate: function (phone) {
      return Boolean(phone) && phone.length >= 10 && phone.length <= 15;
    },
    resetForm: function () {
      for (var item in this.form) {
        this.form[item] = null;
      }
    },
    completeRDEAccount() {
      if (
        this.form.email !== null &&
        this.form.phone !== null &&
        this.form.name !== null &&
        this.phoneValidate(this.form.phone) &&
        this.emailValidate(this.form.email) &&
        this.form.comfirm_password !== null &&
        this.form.name.length > 3 &&
        this.form.comfirm_password === this.form.password &&
        this.form.comfirm_password.length >= 5 &&
        this.form.country !== null
      ) {
        console.log("emit completeRDEAccount");
        this.$emit("completeRDEAccount", [this.form]);
      } else {
        console.log("missing fields");
        // console.log( (this.form.email !== null ) &&
        //     (this.form.phone !== null ) &&
        //     (this.form.name !== null ) &&
        //     (this.phoneValidate(this.form.phone)) &&
        //     (this.emailValidate(this.form.email)) &&
        //     (this.form.comfirm_password !== null ) &&
        //     (this.form.name.length > 3 ) &&
        //     (this.form.comfirm_password === this.form.password) &&
        //     (this.form.comfirm_password.length >= 5) &&
        //     (this.form.country !== null ) )

        console.log("this.form.email", this.form.email !== null);
        console.log("this.form.phone", this.form.phone !== null);
        console.log("this.form.name", this.form.name !== null);
        console.log(
          "this.phoneValidate(this.form.phone)",
          this.phoneValidate(this.form.phone)
        );
        console.log(
          "this.emailValidate(this.form.email)",
          this.emailValidate(this.form.email)
        );
        console.log(
          "this.form.comfirm_password",
          this.form.comfirm_password !== null
        );
        console.log("this.form.name.length > 3", this.form.name.length > 3);
        console.log(
          "this.form.comfirm_password === this.form.password",
          this.form.comfirm_password === this.form.password
        );
        console.log(
          "this.form.comfirm_password.length >= 5",
          this.form.comfirm_password.length >= 5
        );
        console.log("this.form.country !== null", this.form.country !== null);

        let fields = "";
        if (!this.phoneValidate(this.form.phone))
          fields = fields + "Incorrect Phone Number Pattern, ";
        if (!this.emailValidate(this.form.email)) {
          fields = fields + "Email, ";
        }
        if (!this.form.name.length >= 3) {
          fields = fields + "Full Name is too short, ";
        }
        if (!(this.form.comfirm_password === this.form.password)) {
          fields = fields + " Password and Confirm Password does not match";
        }
        if (!(this.form.comfirm_password.length >= 5)) {
          fields = fields + " Password must be at least 5 Characters";
        }
        this.$toast.error(`Error Missing fields:  ${fields}`);
      }
    },
    cancelRDEAccount: function (e) {
      this.$emit("cancelRDEAccount");
      this.resetForm();
    },
  },
};
</script>

<style scoped></style>
